import {carteraTitles} from '@/renameCampos/jsonCarteraTitles';
import {sclTitles} from '@/renameCampos/jsonSCLTitles';
import {EncryptService} from '@/services/EncryptService';

export async function getVocabulario(){
    let tipoCartera = localStorage.getItem('TIPO_CARTERA');   
    
    let tipo_cartera = await EncryptService.decrypt(tipoCartera);
    
    if(tipo_cartera === 'TOTALPLAY'){
        return carteraTitles;
    }
    
    if(tipo_cartera === 'SCL'){
        return sclTitles;
    } 
    
    return {};
}